(function () {
  function initMobileStickyNav() {
    const nav = document.querySelector('[data-mobile-sticky-nav]');

    if (!nav || nav.dataset.initialized === 'true') return;

    nav.dataset.initialized = 'true';

    const updateColumns = function () {
      const items = nav.querySelectorAll('.mobile-sticky-nav__item');
      nav.style.setProperty('--nav-item-count', items.length || 4);
    };

    updateColumns();

    document.addEventListener('shopify:section:load', updateColumns);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileStickyNav);
  } else {
    initMobileStickyNav();
  }
})();